import { useMemo } from 'react';

import { DayOfWeek, TimeOfDay } from '@dreryk/egabinet-waitlist-frontend-api';

import { createTranslatedText, useTranslate, ValidationRules } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { DayPreferenceFormBeanPart } from './DayPreferenceField.types';

export const useTriggerLabelExtractor = (): ((preferences: TimeOfDay[]) => string) => {
   const translate = useTranslate();
   return (preferences) => {
      return preferences.map((preference) => translate(translationKeys.timeOfDayMap[preference])).join(', ');
   };
};

export const useValidationRules = <DAY_OF_WEEK extends DayOfWeek>(): ValidationRules<
   DayPreferenceFormBeanPart<DAY_OF_WEEK>
> =>
   useMemo(
      () => ({
         validate: (_, getValue) => {
            const dayTimePreferences = getValue('dayTimePreferences') as Record<DayOfWeek, TimeOfDay[]>;
            const preferencesEmpty = Object.values(dayTimePreferences).every((preference) => preference.length === 0);
            if (preferencesEmpty) {
               return createTranslatedText('');
            }
            return undefined;
         },
      }),
      []
   );
